import React from "react";
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

const NetworkTabItems = () => {
	return (
		<div className="tab-pane" id="network">
			<Row className="row">
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Virtual Private Cloud</p>
						<p className="box-body">
							Designed to logically isolate and secure your
							cloud-based infrastructure, giving you the ability
							to manage it just as your on-premises network.{" "}
						</p>
						<Link className="learn-more" to="/vpc" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Direct Connect</p>
						<p className="box-body">
							High-speed, stable and secure dedicated network
							connection.
						</p>
						<Link className="learn-more" to="/directconnect" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Elastic IP</p>
						<p className="box-body">
							Your static IP address designed for a dynamic cloud
							computing.
						</p>
						<Link className="learn-more" to="/elasticip" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Load-Balancer As A Service</p>
						<p className="box-body">
							Automatically distributes incoming traffic across
							multiple servers to balance the workload, increasing
							the service capabilities and fault tolerance of your
							applications.
						</p>
						<Link className="learn-more" to="/loadbalancer" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Virtual Private Network</p>
						<p className="box-body">
							Connect with DETASAD cloud using an enterprise grade
							secure Virtual Private Network.
						</p>
						<Link className="learn-more" to="/virtualprivatenetwork" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
			</Row>
		</div>
	);
}

export default NetworkTabItems;
